module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/bnr-kusatsun-onsen-03bad0ee52b1beee5b040ebba1b8ecb9.jpg";